export const G_API = 'https://api.ahnyarinstitute.org/';
// export const G_API = 'http://localhost:5001/';
export const G_DEF_COV = 'default-cover.png';
export const G_MEASURE_ID = 'G-FZP09C1LKG';
export const PAGE_LIMIT = 5;
